import { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import AuthService from '../../services/AuthService';

class Logout extends Component {
  componentWillMount() {
    AuthService.logout();
    this.props.setIsAuthenticated(false);
  }

  render() {
    return (
      <div>
        Login out...
        <Redirect to="/" />
      </div>
    );
  }
}

Logout.propTypes = {
  setIsAuthenticated: PropTypes.func,
};

export default Logout;
